import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { ArrowUpRight, Lock } from 'lucide-react';
import { adminLogin } from '../../lib/api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [u, setU] = useState('admin');
  const [p, setP] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  if (localStorage.getItem('bs_admin_token')) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      const data = await adminLogin(u, p);
      localStorage.setItem('bs_admin_token', data.access_token);
      navigate('/admin', { replace: true });
    } catch (e) {
      setErr('Invalid credentials. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--navy)] text-white flex items-center justify-center wireframe-bg p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-10">
          <div className="relative">
            <span className="font-display text-4xl leading-none">B</span>
            <span className="absolute -right-1 bottom-1 w-2.5 h-2.5 rounded-full bg-[var(--coral)]" />
          </div>
          <div className="font-tag opacity-70">Studio Admin</div>
        </div>
        <h1 className="font-display text-5xl md:text-6xl leading-[0.95]">Sign <span className="font-display-italic text-[var(--coral)]">in.</span></h1>
        <p className="mt-4 opacity-70 text-sm">Hint: <span className="text-[var(--coral)]">admin</span> / <span className="text-[var(--coral)]">bespoke2026</span></p>
        <form onSubmit={submit} className="mt-10 space-y-6">
          <div>
            <div className="font-tag opacity-70 mb-2">Username</div>
            <input value={u} onChange={(e) => setU(e.target.value)} className="w-full bg-transparent border-b border-white/30 focus:border-[var(--coral)] outline-none py-3 text-lg transition-colors" />
          </div>
          <div>
            <div className="font-tag opacity-70 mb-2">Password</div>
            <input type="password" value={p} onChange={(e) => setP(e.target.value)} className="w-full bg-transparent border-b border-white/30 focus:border-[var(--coral)] outline-none py-3 text-lg transition-colors" />
          </div>
          {err && <div className="text-[var(--coral)] text-sm">{err}</div>}
          <button type="submit" disabled={loading} className="pill pill-coral w-full justify-center"><Lock size={14} /><span>{loading ? 'Signing in…' : 'Sign in'}</span><ArrowUpRight size={14} /></button>
        </form>
      </div>
    </div>
  );
}
